import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ProductCard from "../../Enums/ProductCard";
import ProductsService from "../../services/ProductsService";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import "./style.css";

const Products = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation();
	const location = useLocation();
	const lang = useSelector((state) => state?.lang?.lang);
	const search = useSelector((state) => state?.user?.search);
	const productsService = new ProductsService();

	useEffect(() => {
		let params = {};
		if (!!search) params["search"] = search;
		setLoading(true);
		productsService.getList({ ...params }).then((res) => {
			if (res?.status) {
				let response = res?.data?.data?.data?.map((info) => {
					return {
						...info,
						label: lang === "en" ? info?.name_en : info?.name_ar,
						value: info?.id,
					};
				});
				if (!!response?.length) {
					setData(response);
					setHasData(1);
				} else {
					setData([]);
					setHasData(0);
				}
			}
			setLoading(false);
		});
	}, [location, search]);

	return (
		<div className="products-page2 container">
			{loading && (
				<div style={{ minHeight: "90vh", display: "flex" }}>
					<Loader />
				</div>
			)}
			<div>
				{/* {!!categoriesOptions?.length && (
					<div className="categories">
						<div className="d-flex justify-content-between">
							<p className="title">{t("categories")}</p>
							<Link to="/">{t("View All")}</Link>
						</div>
						<div className="row">
							{categoriesOptions?.map((item, index) => {
								return (
									<div
										key={index}
										onClick={() => navigate(`/products/product/${item?.id}`)}
										className="col-md-3 mb-3">
										<div className="category-card">
											<img src={item?.image} alt="category" className="w-100" />
											<p className="title">
												{lang === "en" ? item?.name_en : item?.name_ar}
											</p>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				)} */}
				{hasData === 1 && !loading && (
					<div className="products">
						<div className="row">
							{data?.map((product, index) => {
								return (
									<div className="col-md-3 col-6 mb-3" key={index}>
										<ProductCard product={product} hasAddToCart={true} />
									</div>
								);
							})}
						</div>
					</div>
				)}
				{hasData === 0 && !loading && <NoData text={t(`There's no Product`)} />}
			</div>
		</div>
	);
};

export default Products;
